const PIXEL_ID = '2130620274146187'

declare global {
  interface Window {
    fbq: (...args: unknown[]) => void
    _fbq: (...args: unknown[]) => void
  }
}

let initialized = false

function loadPixelScript() {
  // Create fbq queue function first
  const n: any = (window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })
  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  // Load the script by adding it to head
  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  script.onerror = () => console.warn('Meta Pixel script failed to load')
  document.head.appendChild(script)

  window.fbq('init', PIXEL_ID)
}

export function initPixel() {
  if (initialized) return
  initialized = true

  // Wait for DOM to be fully ready before loading
  if (
    document.readyState === 'complete' ||
    document.readyState === 'interactive'
  ) {
    setTimeout(loadPixelScript, 0)
  } else {
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(loadPixelScript, 0)
    })
  }
}

export function trackPageView() {
  // Delay to ensure fbq is initialized
  setTimeout(() => {
    if (window.fbq) {
      window.fbq('track', 'PageView')
    }
  }, 100)
}

export function trackAddToCart() {
  if (window.fbq) {
    window.fbq('track', 'AddToCart')
  }
}
